
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { StickyNote } from "lucide-react";
import { OrganizationWithRelations } from "@/types/organization.types";

interface ClientGoalsCardProps {
  organization: OrganizationWithRelations;
}

export function ClientGoalsCard({ organization }: ClientGoalsCardProps) {
  if (!organization.client_goals) return null;
  
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Client Goals</CardTitle>
      </CardHeader>
      <CardContent>
        <div>
          <span className="text-sm font-medium text-muted-foreground flex items-center">
            <StickyNote className="h-4 w-4 mr-1" /> Qualitative Goals:
          </span>
          <p className="text-sm mt-1">{organization.client_goals}</p>
        </div>
      </CardContent>
    </Card>
  );
}
